import React, {useEffect} from 'react';
import {Text} from '@wix/wix-ui-tpa/cssVars';
import {PaymentRequestView} from '../PaymentRequestView';
import {useLocaleKeys} from '../../../../locale-keys/LocaleKeys';
import {useControllerProps} from '../../Widget/ControllerContext';
import {classes} from './ThankYouView.st.css';

export enum ThankYouViewDataHook {
  root = 'ThankYouViewDataHook.root',
  view = 'ThankYouViewDataHook.view',
  paymentTitle = 'ThankYouViewDataHook.paymentTitle',
  orderNumber = 'ThankYouViewDataHook.orderNumber',
  amount = 'ThankYouViewDataHook.amount',
}

export const ThankYouView = () => {
  const {
    paymentRequestStore: {paymentRequest, sendPaymentRequestThankYouPageLoadBIEvent},
  } = useControllerProps();
  const localeKeys = useLocaleKeys();
  const orderNumber = paymentRequest.orderNumber !== '0' ? paymentRequest.orderNumber : undefined;
  const amountPaid = paymentRequest.total.formattedAmount;
  const title = paymentRequest.title;
  const shouldShowTitle = !!title;

  useEffect(
    () => {
      sendPaymentRequestThankYouPageLoadBIEvent();
    },
    /* eslint-disable react-hooks/exhaustive-deps */ []
  );

  return (
    <div data-hook={ThankYouViewDataHook.root}>
      <PaymentRequestView
        dataHook={ThankYouViewDataHook.view}
        title={localeKeys.checkout.payLinks.thankYouPage.title()}
      />
      <div className={classes.numberAndAmountContainer}>
        {shouldShowTitle && (
          <Text data-hook={ThankYouViewDataHook.paymentTitle} className={classes.thankYouText}>
            {title}
          </Text>
        )}
        {!shouldShowTitle && orderNumber && (
          <Text data-hook={ThankYouViewDataHook.orderNumber} className={classes.thankYouText}>
            {localeKeys.checkout.payLinks.thankYouPage.orderNumber({incrementalID: orderNumber})}
          </Text>
        )}
        {amountPaid && (
          <Text data-hook={ThankYouViewDataHook.amount} className={classes.thankYouText}>
            {localeKeys.checkout.payLinks.thankYouPage.amountPaid({amountPaid})}
          </Text>
        )}
      </div>
    </div>
  );
};
